// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.go-to-equations {
  color: blue;
  text-decoration: none;
  cursor: pointer;
}
.go-to-equations:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-structure/liquidity-sources/liquidity-sources.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,0BAAA;AACJ","sourcesContent":[".go-to-equations {\r\n  color: blue;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    text-decoration: underline;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
